export const CommunityCardsCountMap = {
  flop: 3,
  turn: 1,
  river: 1
}

export function confirmCardsCount<T>(count: number, data: T[] = []): (T | null)[] {
  if (data.length === count) return [...data]

  const res: (T | null)[] = [...data]
  res.length = count
  return res.fill(null, data.length)
}
